<template>
  <section class="reg-layout">
    <svg class="hidden-desktop mobile-arrow-left" viewBox="0 0 1024 1024" @click.prevent="go">
      <path d="M641.28 278.613333l-45.226667-45.226666-278.634666 278.762666 278.613333 278.485334 45.248-45.269334-233.365333-233.237333z"></path>
    </svg>
    <div class="area">
      <slot></slot>
    </div>

    <language />
    <copy-right class="copyright" />

    <slider />
    <aside :class="`cookie ${state.cookie && 'on'}`">
      <div class="cookie-container">
        <p>
          {{ t('footer.cookieContent') }}
          <a :href="policy">{{ t('footer.learn') }}</a>
        </p>
        <button @click.prevent="handle(true)">{{ t('footer.accept') }}</button>
        <close-outlined @click.prevent="handle(false)" />
      </div>
    </aside>
  </section>
</template>
<script setup>
  import { CloseOutlined } from "@ant-design/icons-vue";
  import Slider from "@c/Slider.vue";
  import CopyRight from "@c/CopyRight.vue";
  import Language from "@c/Language.vue";
  import { COUNTRY_POLICY } from "@u/helpers/siteData";
  import { useStore } from 'vuex';
  import { go } from "@u/helpers/utils"

  const { t } = useI18n();
  const store = useStore();

  const state = reactive({ cookie: false });

  const policy = computed(() => COUNTRY_POLICY.get(store.getters.language.current.cr));


  const handle = (b) => {
    b ? localStorage.setItem("JACKERY_ID_COOKIE", "accept") : sessionStorage.setItem("TEMP_COOKIE", "close")
    state.cookie = false
  }

  onMounted(() => {
    !localStorage.getItem("JACKERY_ID_COOKIE") && !sessionStorage.getItem("TEMP_COOKIE") && setTimeout(() => {
      state.cookie = true
    }, 2000)
  });
</script>

<style scoped lang="less">
  .reg-layout {
    --height: 870px; --pleft: 49.7%;
    width: 100%; max-width: var(--regist-width); height: 100vh; max-height: var(--height); min-height: 550px;
    margin: 0 auto; position: relative; top: calc((100vh - var(--height)) / 2);
    display: flex; align-items: center; flex-wrap: wrap;
    .area {
      width: 100%; height: inherit; max-height: var(--regist-height); padding-left: var(--pleft); background: var(--normal-color);
      box-shadow: 0 2px 34px 0 rgba(0, 0, 0, 0.08); position: relative; z-index: 1;
      display: flex; justify-content: center;
    }
  }
  .cookie {
    width: 100%; height: 80px; background: var(--weak-color3); opacity: 0; pointer-events: none;
    position: fixed; bottom: -100px; left: 0; z-index: 11; transition: all 0.5s ease-out;
    &.on {bottom: 0; opacity: 1; pointer-events: all;}
    &-container {
      width: calc(100% - var(--gap) * 2); max-width: var(--regist-width); height: inherit; margin: 0 auto; position: relative;
      display: flex; align-items: center; flex-wrap: wrap;
    }
    a {text-decoration: underline;}
    p {flex: 60% 0; padding-right: var(--gap);}
    button, .anticon-close {cursor: pointer;}
    button {min-width: 120px; height: 36px; padding: 0 5px; color: var(--brand-color); background: none; border-radius: 4px; border: 1px solid var(--brand-color);}
    .anticon-close {position: absolute; right: 0;}
  }

  @media screen and (min-width: 1024px) {
    .reg-layout .area {align-items: center;}
    .copyright {text-align: right; position: absolute; bottom: -30px; right: 0;}
  }

  @media screen and (max-height: 768px) {
    .reg-layout {
      --height: 96vh; --regist-height: calc(95vh - 100px);
    }
  }

  @media screen and (max-width: 1023px) and (min-width: 541px) {
    .reg-layout {
      --height: 110vh; --regist-height: calc(110vh - 60px);
      width: 74%; height: 110vh; zoom: 0.8; transform: translateY(10vh);
    }
    .register {
      --height: 120vh; --regist-height: calc(120vh - 50px);
      height: 120vh; transform: translateY(15vh);
    }
    .copyright {bottom: -12px;}
  }

  @media screen and (max-width: 540px) {
    .reg-layout {
      --height: auto; --regist-height: auto; top: 0;
      .area {height: auto; padding: 0 var(--gap-pc); box-shadow: none;}
    }
    .copyright {width: 100%; text-align: center; padding-bottom: var(--gap);}
    .cookie {
      height: 230px; background: var(--normal-color); bottom: -250px; box-shadow: 0 0 10px rgba(0,0,0,0.2);
      &-container {padding: var(--gap) 0;}
      p {flex: 100% 0; padding-right: 0;}
      button {width: 100%; background: var(--brand-color); color: var(--normal-color);}
      .anticon-close {top: var(--gap);}
    }
  }
</style>
